import { Skeleton } from '@/components/ui/skeleton'
import { useModulesStore } from '@/stores/modules'
import { AddCircleOutlineOutlined } from '@mui/icons-material'
import { Alert, Button } from '@mui/material'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import { CardModule, ErrorPage } from '../../../components'
import { useHeaderAdmin } from '../../../hooks'
import { Filters } from './filters'
import ModalRegister from './modal-register'
import ModalUpdate from './modal-update'
import { useData } from './use-data'

export default function Modules() {
  const { setAction } = useHeaderAdmin()
  const { isLoading, error, modules, refetch, onItemClick, filteredByLevel } =
    useData()

  const { selectedItem, clearSelectedItem } = useModulesStore()
  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState<boolean>(false)

  const toggleModalRegister = () => setIsModalRegisterOpen(!isModalRegisterOpen)

  const onModuleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const { id } = event.currentTarget
    onItemClick(id)
  }

  const closeModalUpdate = () => {
    clearSelectedItem()
  }

  useEffectOnce(() => {
    setAction(
      <Button onClick={toggleModalRegister}>
        <AddCircleOutlineOutlined />
        <span>Registar</span>
      </Button>,
    )
  })

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>

  if (modules && modules.length <= 0)
    return (
      <>
        <ModalRegister
          onDone={refetch}
          open={isModalRegisterOpen}
          onClose={toggleModalRegister}
        />

        <Alert severity="warning">
          Nada registado ainda,{' '}
          <Button variant="text" onClick={toggleModalRegister}>
            Registar um novo
          </Button>
        </Alert>
      </>
    )

  return (
    <>
      <ModalRegister
        onDone={refetch}
        open={isModalRegisterOpen}
        onClose={toggleModalRegister}
      />
      <ModalUpdate
        onDone={refetch}
        open={selectedItem !== null}
        onClose={closeModalUpdate}
      />

      <Filters isLoading={isLoading} />

      {isLoading ? (
        <div className="flex gap-8 ">
          <Skeleton className="rounded-lg py-4 px-5 w-[190px] h-[174px]" />
          <Skeleton className="rounded-lg py-4 px-5 w-[190px] h-[174px]" />
          <Skeleton className="rounded-lg py-4 px-5 w-[190px] h-[174px]" />
        </div>
      ) : modules ? (
        <ul className="flex flex-wrap gap-8">
          {filteredByLevel
            ? filteredByLevel.map((module) => (
                <li key={module.id}>
                  <CardModule
                    id={module.id}
                    module={module}
                    onClick={onModuleClick}
                  />
                </li>
              ))
            : modules
                .sort((a, b) => a.level - b.level)
                .map((module) => (
                  <li key={module.id}>
                    <CardModule
                      id={module.id}
                      module={module}
                      onClick={onModuleClick}
                    />
                  </li>
                ))}
        </ul>
      ) : (
        <ErrorPage text="Nenhum módulo encontrado" />
      )}
    </>
  )
}
